<template>
    <v-container>
        <v-row>
            <v-col cols="12" v-if="!loadingSearch">
                <v-card>
                    <v-col cols="12">
                        <v-row >
                            <v-col cols="12">
                                <h2 class="text-center">Specimens</h2>
                            </v-col>
                        </v-row>

                        <v-container fluid>
                            <v-row >
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field
                                        clearable
                                        counter="20"
                                        maxlength="20"
                                        v-model="search.specimenDisplayID"
                                        label="Specimen ID"
                                        @keyup.native="checkEnterKeyLoadSpecimens">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        :items="species"
                                        item-text="SpeciesFullName"
                                        item-value="SpeciesID"
                                        v-model="search.speciesID"
                                        label="Species"
                                        clearable
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        :items="suppliers"
                                        item-text="SupplierName"
                                        item-value="SupplierID"
                                        v-model="search.supplierID"
                                        label="Supplier"
                                        clearable
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        :items="activeRooms"
                                        item-text="Text"
                                        item-value="RoomID"
                                        v-model="search.roomID"
                                        label="Room"
                                        clearable
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field
                                        clearable
                                        counter="20"
                                        maxlength="20"
                                        v-model="search.rackNumber"
                                        label="Rack Number">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-select
                                        :items="mortalityStatuses"
                                        item-text="text"
                                        item-value="value"
                                        v-model="search.specimenMortalityStatus"
                                        label="Alive or Dead"
                                        clearable
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-menu
                                        ref="searchMinDateMenu"
                                        v-model="searchMinDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="displayArrivalStartDate"
                                                label="Arrival Start Date"
                                                prepend-icon="event"
                                                readonly
                                                clearable
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker 
                                            v-model="search.searchMinDate"
                                            scrollable
                                            @input="searchMinDateMenu = false"
                                            :title-date-format="datePickerFormat"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-menu
                                        ref="searchMaxDateMenu"
                                        v-model="searchMaxDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="displayArrivalEndDate"
                                                label="Arrival End Date"
                                                prepend-icon="event"
                                                readonly
                                                clearable
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="search.searchMaxDate"
                                            scrollable
                                            @input="searchMaxDateMenu = false"
                                            :title-date-format="datePickerFormat"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-btn block color="primary" :loading="loading" @click="loadSpecimens">Search</v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-btn
                                        v-if="!auth.currentUserIsReadOnly()"
                                        color="info"
                                        block
                                        @click="goToMoveRack"
                                    >
                                        Move Rack
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-btn
                                        v-if="!auth.currentUserIsReadOnly()"
                                        color="success"
                                        block
                                        @click="editSpecimen({ 
                                            Active: true,
                                            ArrivalWeight: ''
                                        })"
                                    >
                                        Add New
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>

                    <v-row >
                        <v-col>
                            <v-data-table
                                :headers="headers"
                                :items="specimens"
                                :loading="loading"
                                :footer-props="footerProps"
                                :sort-by.sync="pagination.sortBy"
                                :sort-desc.sync="pagination.sortDesc"
                                :items-per-page.sync="pagination.rowsPerPage"
                                :page.sync="pagination.page"
                                :server-items-length="totalSpecimens"
                                must-sort
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template v-slot:item.ArrivalDate="{ item }">
                                    {{ item.ArrivalDate | formatDateOnly }}
                                </template>
                                <template v-slot:item.Husbandry="{ item }">
                                    <v-btn
                                        color="accent"
                                        @click="openHusbandry(item.SpecimenDisplayID)"
                                    >
                                        Husbandry
                                    </v-btn>
                                </template>
                                <template v-slot:item.Barcode="{ item }">
                                    <v-btn
                                        color="info"
                                        @click="printBarcode(item.SpecimenDisplayID)"
                                    >
                                        Print Barcode
                                    </v-btn>
                                </template>
                                <template v-slot:item.Edit="{ item }">
                                    <v-btn
                                        color="warning"
                                        @click="editSpecimen(item)"
                                        v-if="!auth.currentUserIsReadOnly()"
                                    >
                                        Edit
                                    </v-btn>
                                </template>
                                <template v-slot:item.Delete="{ item }">
                                    <v-btn
                                        color="error"
                                        block
                                        @click="confirmDeleteSpecimen(item.SpecimenID)"
                                        v-if="auth.hasPermissions([permissions.ACCESS_LEVELS.ADMIN], true)"
                                    >
                                        Delete
                                    </v-btn>
                                </template>
                                <template v-if="!loading" slot="no-data">
                                    <v-alert v-if="loadError" outlined :value="true" color="error" icon="error">
                                        {{loadError}}
                                    </v-alert>
                                    <v-alert v-if="!loadError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="showDeleteConfirmDialog" persistent max-width="600">
            <v-card class="no-padding confirm-dialog">
                <v-card-title class="headline">Confirm Delete</v-card-title>
                <v-card-text>Are you sure you wish to delete this specimen?</v-card-text>
                <v-card-text>This action cannot be undone.</v-card-text>
                <v-card-text>After deletion, this specimen record will no longer appear in this list, but an audit record with the deleted information will still be available.</v-card-text>
                <v-card-actions>
                    <v-row >
                        <v-col cols="6">
                            <v-btn color="success" block @click="cancelDeleteSpecimen()" :loading="deleting">Cancel</v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn color="error" block @click="deleteSpecimen()" :loading="deleting">Delete</v-btn>
                        </v-col>
                        <v-col cols="12" v-if="deleteError">
                            <error-alert :content="deleteError" display="true"></error-alert>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showEditDialog" transition="dialog-bottom-transition" fullscreen>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark :disabled="saving" @click="cancelEditSpecimen">
                        <v-icon large>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-if="editedSpecimen && editedSpecimen.SpecimenID">Edit Specimen</v-toolbar-title>
                    <v-toolbar-title v-else>Add New Specimen</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        
                    </v-toolbar-items>
                </v-toolbar>
                <v-form @submit.prevent ref="editForm" v-model="editSpecimenValid">
                    <v-row class="dialog-content">
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row >
                                <v-col cols="12" v-if="editedSpecimen.SpecimenID">
                                    <v-text-field
                                        disabled
                                        counter="5"
                                        maxlength="5"
                                        v-model="editedSpecimen.SpecimenDisplayID"
                                        label="Specimen ID">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="!editedSpecimen.SpecimenID">
                                    Specimen ID will be automatically generated upon creation
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="species"
                                        item-text="SpeciesFullName"
                                        item-value="SpeciesID"
                                        v-model="editedSpecimen.SpeciesID"
                                        label="Species"
                                        :rules="[rules.selectIDRequired]"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="suppliers"
                                        item-text="SupplierName"
                                        item-value="SupplierID"
                                        v-model="editedSpecimen.SupplierID"
                                        label="Supplier"
                                        :rules="[rules.selectIDRequired]"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-menu
                                        ref="arrivalDateMenu"
                                        v-model="arrivalDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="displayArrivalDate"
                                                label="Arrival Date"
                                                prepend-icon="event"
                                                readonly
                                                :rules="[rules.required]"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker 
                                            v-model="editedSpecimen.ArrivalDate"
                                            scrollable
                                            @input="arrivalDateMenu = false"
                                            :title-date-format="datePickerFormat"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" v-if="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0">
                                    <v-alert outlined :value="true" type="info">
                                        The current weight and location can only be edited on the Daily Husbandry page for this specimen
                                        <v-btn
                                            color="accent"
                                            @click="openHusbandry(editedSpecimen.SpecimenDisplayID)"
                                        >
                                            Husbandry
                                        </v-btn>
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" v-if="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0">
                                    <NumericEntry
                                        v-model="editedSpecimen.CurrentWeight"
                                        label="Current Weight"
                                        :rules="[]"
                                        v-bind="arrivalWeightConfig"
                                        disabled
                                        suffix="g">
                                    </NumericEntry>
                                </v-col>
                                <v-col cols="12" v-else>
                                    <NumericEntry
                                        v-model="editedSpecimen.ArrivalWeight"
                                        label="Arrival Weight"
                                        :rules="[]"
                                        v-bind="arrivalWeightConfig"
                                        suffix="g">
                                    </NumericEntry>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="activeLocationTypes"
                                        item-text="Text"
                                        item-value="LocationTypeID"
                                        v-model="editedSpecimen.LocationTypeID"
                                        label="Location Type"
                                        :rules="[rules.selectIDRequired]"
                                        :disabled="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="filteredVenomTypes"
                                        item-text="VenomTypeName"
                                        item-value="VenomTypeID"
                                        item-disabled="disabled"
                                        v-model="editedSpecimen.VenomTypes"
                                        label="Venom Type"
                                        :multiple="true"
                                        return-object
                                        clearable
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="geographicLocations"
                                        item-text="GeographicalLocationName"
                                        item-value="GeographicalLocationID"
                                        v-model="editedSpecimen.GeographicalLocationID"
                                        label="Geographical Location"
                                        :rules="[rules.selectIDRequired]"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="activeRooms"
                                        item-text="Text"
                                        item-value="RoomID"
                                        v-model="editedSpecimen.RoomID"
                                        label="Room"
                                        :rules="[rules.selectIDRequired]"
                                        :disabled="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="activeSuiteNumbers"
                                        item-text="Text"
                                        item-value="SuiteNumberID"
                                        v-model="editedSpecimen.SuiteNumberID"
                                        label="Suite Number"
                                        :rules="[rules.selectIDRequired]"
                                        :disabled="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editedSpecimen.RackNumber"
                                        label="Rack Number"
                                        counter="200"
                                        maxlength="200"
                                        :rules="rackNumberRules"
                                        :disabled="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="activeOrUnknownDrawers"
                                        item-text="Text"
                                        item-value="DrawerID"
                                        v-model="editedSpecimen.DrawerID"
                                        label="Drawer"
                                        :rules="[rules.selectIDRequired]"
                                        :disabled="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :items="genders"
                                        item-text="name"
                                        item-value="value"
                                        v-model="editedSpecimen.Gender"
                                        label="Gender"
                                        :rules="[]"
                                    ></v-select>
                                </v-col>
                                <!-- only show deceased checkbox at all if we are editing, not when adding -->
                                <v-col cols="12" v-if="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0 && editedSpecimenOriginalDeceasedValue && !auth.hasPermissions([permissions.ACCESS_LEVELS.ADMIN], true)">
                                    <v-alert outlined :value="true" type="info">
                                        Reverting the deceased status of a snake can only be done by users with administrator permissions
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" v-if="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0 && !editedSpecimenOriginalDeceasedValue">
                                    <v-alert outlined :value="true" type="info">
                                        Setting a specimen to deceased can only be done on the Daily Husbandry page for this specimen
                                        <v-btn
                                            color="accent"
                                            @click="openHusbandry(editedSpecimen.SpecimenDisplayID)"
                                        >
                                            Husbandry
                                        </v-btn>
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" v-if="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0">
                                    <v-switch
                                        v-model="editedSpecimen.Deceased"
                                        :label="editedSpecimen.Deceased ? 'Deceased' : 'Not Deceased'"
                                        :disabled="!auth.hasPermissions([permissions.ACCESS_LEVELS.ADMIN], true) || !editedSpecimenOriginalDeceasedValue"
                                    >
                                    </v-switch>
                                </v-col>
                                <v-col cols="12" v-if="editedSpecimen.SpecimenID && editedSpecimen.SpecimenID > 0">
                                    <v-switch
                                        v-model="editedSpecimen.Euthanised"
                                        :label="editedSpecimen.Euthanised ? 'Euthanised' : 'Not Euthanised'"
                                        :disabled="!auth.hasPermissions([permissions.ACCESS_LEVELS.ADMIN], true) || !editedSpecimenOriginalDeceasedValue"
                                    >
                                    </v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea
                                        filled
                                        counter="8000"
                                        maxlength="8000"
                                        v-model="editedSpecimen.MiscellaneousInformation"
                                        label="Miscellaneous Information">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="editedSpecimen.SprayedAndNeutered"
                                        label="Spayed/Neutered"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="editedSpecimen.Spinal"
                                        label="Spinal"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="editedSpecimen.FxRibs"
                                        label="FxRibs"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="editedSpecimen.Scars"
                                        label="Scars"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="editedSpecimen.Deformities"
                                        label="Deformities"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="editedSpecimen.Aggressive"
                                        label="Aggressive"
                                    >
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox
                                        v-model="editedSpecimen.Other"
                                        label="Other"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="editedSpecimen.OtherDescription"
                                        v-if="editedSpecimen.Other"
                                        label="Description"
                                        counter="1000"
                                        maxlength="1000"
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row  class="dialog-action-buttons">
                                <v-col cols="12" sm="2">
                                    <v-btn block color="error" :disabled="saving" @click="cancelEditSpecimen">Cancel</v-btn>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn block color="info" v-if="editedSpecimen.SpecimenID" @click="exportSpecimen" :disabled="exporting" :loading="exporting">Export</v-btn>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-btn block color="info" v-if="editedSpecimen.SpecimenID" @click="printSpecimen">Print</v-btn>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-btn block color="success" :disabled="!editSpecimenValid" :loading="saving" @click="saveEditedSpecimen">Confirm and Save</v-btn>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-btn block color="success" :disabled="!editSpecimenValid" :loading="saving" @click="saveAndAddNewSpecimen">Save and Add New</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="saveError">
                                    <v-alert text type="error">{{ saveError }}</v-alert>
                                </v-col>
                            </v-row>                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackbars.specimenDisplayIDChanged"
            multi-line
            color="info"
            :timeout="-1"
        >
            Please note: The Specimen Display ID was modified because the species or the year of the arrival date was changed.
            <v-btn
                text
                @click="snackbars.specimenDisplayIDChanged = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-snackbar
            v-model="snackbars.confirmAndAddNewSaved"
            multi-line
            color="success"
            :timeout="3000"
            top
        >
            Specimen successfully saved
            <v-btn
                text
                @click="snackbars.confirmAndAddNewSaved = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import NumericEntry from "../common/NumericEntry";
import moment from 'moment'
import util from '@/helpers/util';
import GlobalEventBus from '@/globalEventBus';
import constants from 'comunet-btg-utah-repository-shared/constants';
import * as auth from '@/services/auth';
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import exports from "@/services/export";
import * as SpecimenAPI from "@/services/specimenAPI"
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    components: {
        ErrorAlert,
        NumericEntry
    },
    props: {
        openNewSpecimen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            auth: auth,
            permissions: permissions,
            snackbars: {
                specimenDisplayIDChanged: false,
                confirmAndAddNewSaved: false
            },
            showDeleteConfirmDialog: false,
            deletedSpecimenID: null,
            specimensLoading: false,
            specimens: [],
            editedSpecimen: {
                ArrivalDate: ""
            },
            totalSpecimens: 0,
            editSpecimenValid: false,
            rules: validationRules.rules,
            searchFormValid: false,
            searchMinDateMenu: false,
            searchMaxDateMenu: false,
            arrivalDateMenu: false,
            showEditDialog:false,
            editedSpecimenOriginalDeceasedValue: false,
            arrivalWeightConfig: {
                decimalPlaces: 2,
                minValue: 0,
                maxValue: 999999
            },
            search: {
                searchMinDate: "",
                searchMaxDate: "",
                specimenMortalityStatus: 2 // Alive - see mortalityStatuses below
            },
            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "ArrivalDate",
                sortDesc: true,
                page: 1
            },
            headers: [
                {
                    text: "Specimen ID",
                    value: "SpecimenDisplayID"
                },
                {
                    text: "Species",
                    value: "SpeciesFullName"
                },
                {
                    text: "Supplier",
                    value: "SupplierName"
                },
                {
                    text: "Arrival Date",
                    value: "ArrivalDate"
                },
                {
                    text: "Room",
                    value: "RoomText"
                },
                {
                    text: "Rack Number",
                    value: "RackNumber"
                },
                {
                    text: "", // husbandry
                    sortable: false,
                    value: "Husbandry",
                    class: "force-small-column"
                },
                {
                    text: "", // barcode button
                    sortable: false,
                    value: "Barcode",
                    class: "force-small-column"
                },
                {
                    text: "", // edit button
                    sortable: false,
                    value: "Edit",
                    class: "force-small-column"
                },
                {
                    text: "", // delete button
                    sortable: false,
                    value: "Delete",
                    class: "force-small-column"
                }
            ],
            mortalityStatuses: [
                { text: "All", value: 0 },
                { text: "Deceased", value: 1 },
                { text: "Alive", value: 2 }
            ],
            exporting: false
        };
    },
    watch: {
        pagination: {
            handler(){
                this.loadSpecimens();
            },
            deep: true
        }
    },
    filters: {
        // ensure data stored as a date only (ie no timezone) is formatted correctly
        formatDateOnly: function(value) {
            return moment.utc(value).format(constants.DATE_FORMAT_NO_TIME);
        }
    },
    computed: {
        ...mapGetters({
            activeLocationTypes: "locationStore/activeLocationTypes",
            activeSuiteNumbers: "locationStore/activeSuiteNumbers",
            activeRooms: "locationStore/activeRooms",
            activeDrawers: "locationStore/activeDrawers",
            geographicLocations: "locationStore/geographicLocations",
        }),
        ...mapState("locationStore", {
            locationTypes: state => state.locationTypes,
            suiteNumbers: state => state.suiteNumbers,
            rooms: state => state.rooms,
            drawers: state => state.drawers,
        }),
        ...mapState("venomTypeStore", {
            allVenomTypes: state => state.venomTypes,
        }),
        filteredVenomTypes() {
            let activeVenomTypes = this.allVenomTypes.filter(vt => { return vt.Active })
            .map(vt => {
                return {
                    disabled: false,
                    VenomTypeID: vt.VenomTypeID,
                    VenomTypeName: vt.VenomTypeName,
                }
            })

            //is a specimen being edited?
            if (this.editedSpecimen.SpecimenID && this.editedSpecimen.SpecimenID > 0){
                //  does the specimen have venom types?
                if (this.editedSpecimen.VenomTypes != undefined) {
                    this.editedSpecimen.VenomTypes.forEach(vt => {
                        if( !activeVenomTypes.includes(x => { x.VenomTypeID == vt.VenomTypeID}) ) {
                            var vtObj = this.allVenomTypes.find(x => { return x.VenomTypeID == vt.VenomTypeID})
                            //push disabled venom type into filtered array for display
                            activeVenomTypes.push({
                                disabled: true,
                                VenomTypeID: vtObj.VenomTypeID,
                                VenomTypeName: vtObj.VenomTypeName,
                            })
                        }
                    });
                }
            }
            
            return activeVenomTypes;
        },
        activeOrUnknownDrawers(){
            if (this.editedSpecimen.SpecimenID && this.editedSpecimen.SpecimenID > 0){
                var newDrawers = [...this.activeDrawers];
                newDrawers.push({
                    DrawerID: -1,
                    Text: "Unknown"
                });

                return newDrawers;
            }else {
                return this.activeDrawers;
            }
        },
        displayArrivalDate: {
            get: function() {
                if (this.editedSpecimen && this.editedSpecimen.ArrivalDate) {
                    return moment.utc(this.editedSpecimen.ArrivalDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.editedSpecimen.ArrivalDate = newValue;
            }
        },
        displayArrivalStartDate: {
            get: function() {
                if (this.search && this.search.searchMinDate) {
                    return moment.utc(this.search.searchMinDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchMinDate = newValue;
            }
        },
        displayArrivalEndDate: {
            get: function() {
                if (this.search && this.search.searchMaxDate) {
                    return moment.utc(this.search.searchMaxDate).format(constants.DATE_FORMAT_NO_TIME);
                }

                return "";
            },
            set: function(newValue) {
                this.search.searchMaxDate = newValue;
            }
        },
        loadingSearch() {
            return this.$store.state.locationStore.loading
                || this.$store.state.speciesStore.loading
                || this.$store.state.supplierStore.loading;
        },
        loading() {
            return this.specimensLoading
                || this.$store.state.locationStore.loading
                || this.$store.state.speciesStore.loading
                || this.$store.state.supplierStore.loading;
        },
        loadError() {
            return this.$store.state.specimenStore.loadError;
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active && s.IsSpecimenSupplier).sort(util.sortByField("SupplierName"));
        },
        saveError() {
            return this.$store.state.specimenStore.saveError;
        },
        saving() {
            return this.$store.state.specimenStore.saving;
        },
        deleteError() {
            return this.$store.state.specimenStore.deleteError;
        },
        deleting() {
            return this.$store.state.specimenStore.deleting;
        },
        genders() {
            return constants.GENDERS;
        },
        rackNumberRules() {
            if (this.editedSpecimen.SpecimenID && this.editedSpecimen.SpecimenID > 0) {
                return []
            } else {
                return [this.rules.required];
            }
        }
    },
    methods: {
        checkEnterKeyLoadSpecimens(event){
            if (event.keyCode === 13){
                this.loadSpecimens();
            }
        },
        datePickerFormat(date) {
            return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
        },
        loadSpecimens() {
            this.specimensLoading = true;

            let that = this;
            this.$store.dispatch("specimenStore/loadSpecimens", {
                params: {
                    PaginationPage: this.pagination.page,
                    PaginationPageSize: this.pagination.rowsPerPage,
                    SortBy: this.pagination.sortBy,
                    SortDirection: this.pagination.sortDesc ? "DESC" : "ASC",
                    SearchMinDate: this.search.searchMinDate,
                    SearchMaxDate: this.search.searchMaxDate,
                    SpecimenDisplayID: this.search.specimenDisplayID,
                    SpeciesID: this.search.speciesID,
                    SpecimenSourceID: this.search.specimenSourceID,
                    SupplierID: this.search.supplierID,
                    RoomID: this.search.roomID,
                    RackNumber: this.search.rackNumber,
                    SpecimenMortalityStatus: this.search.specimenMortalityStatus
                },
                success: (data) => {
                    // Decorate objects with necessary referenced objects
                    that.specimens = data.Specimens.map(function (l){
                        var locationType = that.locationTypes.find(x => x.LocationTypeID == l.LocationTypeID);
                        l.LocationType = locationType;

                        var suiteNumber = that.suiteNumbers.find(x => x.SuiteNumberID == l.SuiteNumberID);
                        l.SuiteNumber = suiteNumber;

                        var room = that.rooms.find(x => x.RoomID == l.RoomID);
                        l.Room = room;

                        var species = that.$store.state.speciesStore.species.find(x => x.SpeciesID == l.SpeciesID);
                        l.Species = species;

                        var supplier = that.$store.state.supplierStore.suppliers.find(x => x.SupplierID == l.SupplierID);
                        l.Supplier = supplier;

                        return l;
                    });
                    that.totalSpecimens = data.TotalSpecimens;
                },
                error: () => {
                    that.totalSpecimens = 0;
                    that.specimens = [];
                },
                finally: () => {
                    that.specimensLoading = false;
                }
            });
        },
        goToMoveRack() {
            this.$router.push({ name: 'moverack' });
        },
        editSpecimen (item) {
            this.$store.dispatch("specimenStore/clearSaveError");
            SpecimenAPI.getSpecimenVenomTypes({SpecimenID: item.SpecimenID}).then(result => {
                // console.log('specimin venom types: ', result)
                item.VenomTypes = result
                this.editedSpecimen = Object.assign({}, item);
            })
            .catch(() => {
                // console.log('specimin venom default to empty ')
                item.VenomTypes = []
                this.editedSpecimen = Object.assign({}, item);
            })
            .finally(() => {
                // console.log(this.editedSpecimen)
            });

            this.editedSpecimen = Object.assign({}, item);
            

            this.editedSpecimenOriginalDeceasedValue = this.editedSpecimen.Deceased;

            // this is to solve issue "RangeError: Invalid time value"
            // https://github.com/vuetifyjs/vuetify/issues/596
            if (this.editedSpecimen.ArrivalDate) {
                this.editedSpecimen.ArrivalDate = moment.utc(this.editedSpecimen.ArrivalDate).format("YYYY-MM-DD");
            }
            
            this.showEditDialog = true;

            // show which fields are mandatory when opening the edit form
            this.$nextTick(() => this.$refs.editForm.validate());
        },
        cancelEditSpecimen() {
            this.showEditDialog = false;
            this.editedSpecimen = {};
        },
        deleteEditedSpecimenDataBeforeSaving(s) {
            delete s.Species;
            delete s.Supplier;
            delete s.LocationType;
            delete s.SuiteNumber;
            delete s.Room;
            delete s.CurrentWeight;
            delete s.LocationTypeText;
            delete s.SuiteNumberText;
            delete s.RoomText;
            delete s.DrawerText;
            delete s.SupplierName;
        },
        async exportSpecimen() {
            this.exporting = true;

            await exports.exportSpecimen(this.editedSpecimen.SpecimenID);
            
            this.exporting = false;
        },
        printSpecimen() {
            let routeData = this.$router.resolve({name: 'printspecimen', params: { specimenID: this.editedSpecimen.SpecimenID }});
            window.open(routeData.href, '_blank');
        },
        saveEditedSpecimen() {
            var that = this;

            this.deleteEditedSpecimenDataBeforeSaving(this.editedSpecimen);

            this.$store.dispatch("specimenStore/saveSpecimen", {
                specimen: this.editedSpecimen,
                success: function(response) {
                    if (response.data && response.data.specimenDisplayIDRegenerated) {
                        // show a snackbar just letting the user know that the specimen display ID was changed
                        that.snackbars.specimenDisplayIDChanged = true;
                    }
                },
                finally: function() {
                    if (that.$store.state.specimenStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.loadSpecimens();
                        that.cancelEditSpecimen();
                    }
                }
            });
        },
        saveAndAddNewSpecimen(){
            var that = this;

            this.deleteEditedSpecimenDataBeforeSaving(this.editedSpecimen);

            this.$store.dispatch("specimenStore/saveSpecimen", {
                specimen: this.editedSpecimen,
                success: function(response) {
                    if (response.data && response.data.specimenDisplayIDRegenerated) {
                        // show a snackbar just letting the user know that the specimen display ID was changed
                        that.snackbars.specimenDisplayIDChanged = true;
                    }

                    // show a snackbar just to let the user know that something happened
                    that.snackbars.confirmAndAddNewSaved = true;
                },
                finally: function() {
                    var toEditSpecimen = {
                        Active: true,
                        SpeciesID: that.editedSpecimen.SpeciesID,
                        SupplierID: that.editedSpecimen.SupplierID,
                        ArrivalDate: that.editedSpecimen.ArrivalDate,
                        LocationTypeID: that.editedSpecimen.LocationTypeID,
                        SuiteNumberID: that.editedSpecimen.SuiteNumberID,
                        RackNumber: that.editedSpecimen.RackNumber,
                        RoomID: that.editedSpecimen.RoomID,
                        DrawerID: that.editedSpecimen.DrawerID,
                        GeographicalLocationID: that.editSpecimen.GeographicalLocationID,
                        ArrivalWeight: ""
                    };

                    if (that.$store.state.specimenStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.loadSpecimens();
                        that.cancelEditSpecimen();

                        that.editSpecimen(toEditSpecimen)
                    }
                }
            });
        },
        openHusbandry(id) {
            this.$router.push({ name: 'husbandrywithid', params: { specimenDisplayID: id } });
        },
        cancelDeleteSpecimen() {
            this.deletedSpecimenID = null;
            this.showDeleteConfirmDialog = false;
        },
        confirmDeleteSpecimen(specimenID) {
            this.$store.dispatch("specimenStore/clearDeleteError");
            this.deletedSpecimenID = specimenID;
            this.showDeleteConfirmDialog = true;
        },
        deleteSpecimen() {
            var that = this;

            this.$store.dispatch("specimenStore/deleteSpecimen", {
                specimenID: this.deletedSpecimenID,
                success: function() {
                    // close the dialog and reload the grid data
                    that.cancelDeleteSpecimen();
                    that.loadSpecimens();
                }
            });
        },
        printBarcode(id){
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: id }});
            window.open(routeData.href, '_blank');
        },
        processScan(scan) {
            if (scan.specimenDisplayID != ""){
                this.search.specimenDisplayID = scan.specimenDisplayID;
                this.search.speciesID = "";
                this.search.specimenSourceID = "";
                this.search.searchMinDate = "";
                this.search.searchMaxDate = "";
                this.search.searchMaxDate = "";
                this.loadSpecimens();
            }
        }
    },
    created() {
        this.$store.dispatch("venomTypeStore/loadVenomTypes");
        this.$store.dispatch("supplierStore/loadSuppliers");
        this.$store.dispatch("speciesStore/loadSpecies");
        this.$store.dispatch("locationStore/loadLocationTypes");
        this.$store.dispatch("locationStore/loadSuiteNumbers");
        this.$store.dispatch("locationStore/loadRooms");
        this.$store.dispatch("locationStore/loadGeographicLocations");
        this.$store.dispatch("locationStore/loadDrawers");

        if(!this.search){
            this.search = {};
        }

        if (!this.search.specimenDisplayID){
            this.search.specimenDisplayID = "";
        }

        if (!this.search.speciesID){
            this.search.speciesID = "";
        }

        if (!this.search.supplierID){
            this.search.supplierID = "";
        }

        if (!this.search.specimenSourceID){
            this.search.specimenSourceID = "";
        }

        if (!this.search.searchMinDate){
            this.search.searchMinDate = "";
        }

        if (!this.search.searchMaxDate){
            this.search.searchMaxDate = "";
        }

        if (!this.search.roomID){
            this.search.roomID = "";
        }

        if (!this.search.rackNumber){
            this.search.rackNumber = "";
        }

        this.loadSpecimens();

        GlobalEventBus.$on('onScan', this.processScan);
    },
    mounted() {
        if (this.openNewSpecimen) {
            this.editSpecimen({ 
                Active: true,
                ArrivalWeight: ''
            });
        }
    },
    beforeDestroy(){
        GlobalEventBus.$off('onScan', this.processScan);
    }
};
</script>

<style>
    .force-small-column {
        width:1%
    }
</style>